import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Define the full list of services based on your image
const servicesData = [
  {
    title: "Branding",
    desc: "Build a strong and memorable brand identity with strategic design, messaging, and visual consistency.",
    iconClass: "bi bi-palette text-success fs-4 bg-light p-3 rounded",
  },
  {
    title: "Marketing",
    desc: "Grow your business with data-driven marketing strategies that increase visibility, engagement, and leads.",
    iconClass: "bi bi-brush text-info fs-4 bg-light p-3 rounded",
  },
  {
    title: "Personalised Web Development",
    desc: "Custom websites and web applications tailored to your business goals.",
    iconClass: "bi bi-lightbulb text-warning fs-4 bg-light p-3 rounded",
  },
  {
    title: "Awesome Support",
    desc: "Awesome Support is the most versatile and feature-rich support plugin for all version.",
    iconClass: "bi bi-headset text-primary fs-4 bg-light p-3 rounded",
  },
  {
    title: "Digital Grampanchyat",
    desc: "Empowering villages with a digital platform for governance, citizen services, announcements, and transparent administration.",
    iconClass: "bi bi-layers text-danger fs-4 bg-light p-3 rounded",
  },
  {
    title: "Whatsapp Chatbot services and Whatsapp marketing",
    desc: "Automate customer interactions, generate leads, send instant updates, and boost engagement with powerful WhatsApp chatbot and marketing solutions.",
    iconClass: "bi bi-gear text-secondary fs-4 bg-light p-3 rounded",
  },
  {
    title: "Server hosting and cloud support",
    desc: "Reliable server hosting and cloud solutions designed to ensure high performance, security, scalability, and uninterrupted business operations.",
    iconClass: "bi bi-laptop text-info fs-4 bg-light p-3 rounded",
  },
  {
    title: "Hospital CRM",
    desc: "A comprehensive CRM solution designed specifically for healthcare institutions to manage patient relationships and streamline operations.",
    iconClass: "bi bi-hospital text-primary fs-4 bg-light p-3 rounded",
  },
  {
    title: "Office CRM",
    desc: "A comprehensive CRM solution designed specifically for office environments to manage customer relationships and streamline operations.",
    iconClass: "bi bi-briefcase text-dark fs-4 bg-light p-3 rounded",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-5 bg-white">
      <Container className="py-5">
        {/* 1. Header Section */}
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="fw-bold text-dark display-6 mb-3">
              An IT Company creating innovative <br /> & modern impact
            </h2>
            <p className="text-secondary px-lg-5 fs-6 lh-base">
              To achieve this, it would be necessary to have uniform grammar,
              pronunciation and more common words. If several languages coalesce
              the grammar
            </p>
          </Col>
        </Row>

        {/* 2. Grid Section (3 Columns on large screens, 1 Column on mobile) */}
        <Row className="g-5">
          {servicesData.map((item, index) => (
            <Col lg={4} md={6} key={index}>
              <div className="d-flex align-items-start">
                {/* Left Side: Icon Container */}
                <div className="me-3 flex-shrink-0">
                  <i className={item.iconClass}></i>
                </div>

                {/* Right Side: Text Content */}
                <div>
                  <h5 className="fw-semibold text-dark mb-2 fs-5">
                    {item.title}
                  </h5>
                  <p className="text-secondary fs-6 lh-base mb-2">
                    {item.desc}
                  </p>

                  {/* can be used for a "Learn More" link or button if needed in the future */}
                  {/* <a
                    href={`#${item.title.toLowerCase().replace(/ /g, "-")}`}
                    className="text-decoration-none fw-medium fs-6 text-primary"
                  >
                    Learn More <i className="bi bi-chevron-right small"></i>
                  </a> */}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
